import * as React from "react";

import { nullElement } from "../../../../TypingUtils";

import { ErrorLogTooltip } from "./ErrorLogTooltip";

export interface CustomErrorLogTooltipProps {
    show?: boolean;
    anchorElement?: HTMLElement;
    render: () => React.ReactNode;
    onCloseTooltip: () => void;
    isTargetEdited: boolean;
}

export function CustomErrorLogTooltip({
    show,
    anchorElement,
    ...props
}: CustomErrorLogTooltipProps): null | JSX.Element {
    if (show == false || anchorElement == undefined) {
        return nullElement;
    }
    return <ErrorLogTooltip {...props} anchorElement={anchorElement} />;
}
